import _ from 'lodash'
import BUSINESS_INFO_CONFIG from './config'

class BusinessInfoClass {
    constructor() {
        this.DOM = {
            section: BUSINESS_INFO_CONFIG.section,
            trigger: BUSINESS_INFO_CONFIG.trigger
        }

        this.state = false
        this.DOM.section ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.trigger.addEventListener( 'click', this._state.bind( this ) )
    }

    _state() {
        this.state ? this._hide() : this._show()
        this.state = !this.state
    }

    _show() {
        _.addClass( this.DOM.section, 'is--active' )
    }
    _hide() {
        _.removeClass( this.DOM.section, 'is--active' )
    }
}

const BUSINESS_INFO = new BusinessInfoClass()
export default BUSINESS_INFO